import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseAPI } from '@models/response';
import { SalesModel, StatisticsModel } from './n08.model';

@Injectable({
  providedIn: 'root'
})
export class N08Service {
  constructor(private http: HttpClient) {
  }
  getStatistic() {
    return this.http.get<ResponseAPI<StatisticsModel>>(`/N081`);
  }

  getN082(page: number, size: number) {
    return this.http.get<ResponseAPI<SalesModel>>(`/N082?page=${page}&size=${size}`);
  }
}
